<template>
  <div class="row">
    <div class="col-xs-12">
      <div class="form-field select2">
        <div class="select2-field">
          <v-select
            @search="onSearchClientes"
            placeholder="Realice una consulta..."
            id="geocerca"
            v-model="selectedCliente"
            label="nombre"
            :options="clientesExistentes"
            @input="inputCliente"
          ></v-select>
          <label for="geocerca">Cliente</label>
        </div>
      </div>
    </div>
    <div class="col-xs-12">
      <div style="max-height: 300px" class="table-responsive">
        <table>
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Dirección</th>
              <th>Latitud</th>
              <th>Longitud</th>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(cliente, index) in clientes" :key="cliente.id">
              <td>
                {{ cliente.nombre }}
              </td>
              <td>
                {{ cliente.direccion }}
              </td>
              <td>
                {{ cliente.latitud }}
              </td>
              <td>
                {{ cliente.longitud }}
              </td>
              <td>
                <button
                  v-show="cliente.latitud != '' && cliente.longitud != '' && cliente.latitud != null && cliente.longitud != null"
                  @click="ver(index)"
                  type="button"
                  class="btn-primary btn--text"
                >
                  <i class="fa fa-eye"></i>
                </button>
                <button
                  @click="eliminar(index)"
                  type="button"
                  class="btn-danger btn--text"
                >
                  <i class="fa fa-times"></i>
                </button>
              </td>
            </tr>
            <tr v-show="clientes.length === 0">
              <td colspan="5">
                <strong>No se ha agregado clientes</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    ver: function (index) {
      this.$emit("verCliente", index);
    },
    onSearchClientes: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.clientesExistentes = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/clientes?search=" + search, true);
      xmlhttp.send();
    },
    inputCliente: function () {
      if (this.selectedCliente != null) {
        let existente = false;
        for (let i = 0; i < this.clientes.length; i++) {
          if (this.clientes[i].id == this.selectedCliente.id) {
            existente = true;
            break;
          }
        }
        if (!existente) {
          let index =
            this.clientes.push({
              id: this.selectedCliente.id,
              nombre: this.selectedCliente.nombre,
              direccion: this.selectedCliente.direccion,
              latitud: this.selectedCliente.latitud,
              longitud: this.selectedCliente.longitud,
            }) - 1;
          this.ver(index);
        }
        setTimeout(() => {
          this.selectedCliente = null;
        }, 500);
      }
    },
    eliminar: function (index) {
      this.clientes.splice(index, 1);
    },
  },
  data: function () {
    return {
      clientes: this.value,
      selectedCliente: null,
      clientesExistentes: [],
    };
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/rutas/ClientesRuta.vue